<template>
  <v-container fluid>
    <v-card class="pa-8">
      <div class="d-flex align-center mb-8">
        <DateFilter ref="dateFilter" :minusDaysForStartDate="30" />
        <v-select
          v-model="selectedSoftware"
          :items="softwareItems"
          label="Выберите модуль"
          item-text="text"
          item-value="value"
          outlined
          hide-details
          class="ml-4"
          style="width: 1500px !important;"
        ></v-select>
        <v-btn
          @click="applySelection"
          variant="flat"
          color="green"
          dark
          class="ml-4"
        >
          Применить фильтр
        </v-btn>
        <v-btn
          @click="createExcel"
          variant="flat"
          :color="hasData ? 'green' : 'grey'"
          dark
          class="ml-4"
        >
          Выгрузить в xlsx
        </v-btn>
      </div>
      
      <v-card v-if="!loading" class="mb-8">
        <ColumnChart :names="getNames" :series="getSeries"></ColumnChart>
      </v-card>
      <v-card v-else>
        <v-card-text>Данные отсутствуют</v-card-text>
      </v-card>

      <v-card v-if="!loading">
        <Table :headersTable="[{ text: 'Метод', value: 'method' }, { text: 'Всего', value: 'count', align: 'center' }]" :itemsTable="tableItems" :search="true" />
      </v-card>
    </v-card>
  </v-container>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Table from "./Software/Table.vue";
import ColumnChart from './ColumnChart.vue';
import DateFilter from './DateFilter.vue';
//   import SOFTWARE_CODES from '../../constants.js';

export default {
  components: {
    DateFilter,
    ColumnChart,
    Table,
  },
  watch: {
    analyticsData: {
      handler() {
        this.hasData = this.analyticsData.length !== 0;
        this.showChartTable = this.analyticsData.length !== 0;
      },
    },
  },
  data() {
    const today = new Date();
    const beginDate = new Date();
    beginDate.setDate(today.getDate() - 30);

    return {
      dateBegin: beginDate.toISOString().substring(0, 10),
      dateEnd: today.toISOString().substring(0, 10),
      hasData: null,
      showChartTable: null,
      
      selectedSoftware: null,
      softwareItems: [],
      loading: true,
      tableItems: [],
    };
  },
  computed: {
    ...mapGetters([
      "seriesNamesSum",
      "chartSeriesSum",
      "analyticsData",
      "softwareData",
      "url",
    ]),
    getNames() {
      return this.seriesNamesSum;
    },
    getSeries() {
      return this.chartSeriesSum;
    },
  },
  async created() {
    await this.createSoftwareData();
    this.prepareSoftwareItems();
  },
  methods: {
    ...mapActions([
      "createAnalyticsData",
      "createBaseMetricsSum",
      "createSoftwareData",
      "createExcelFile",
    ]),
    ...mapMutations(['setSnackbar']),
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    prepareSoftwareItems() {
      this.softwareItems = Object.keys(this.softwareData).map(key => ({
        text: this.softwareData[key],
        value: key,
      }));
    },
    async applySelection() {
      this.tableItems = [];
      this.dateBegin = this.$refs.dateFilter.getDateBegin();
      this.dateEnd = this.$refs.dateFilter.getDateEnd();
      let r;
      if (this.selectedSoftware) {
        this.loading = true;
        try {
          r = await this.createBaseMetricsSum({
            dateBegin: this.dateBegin,
            dateEnd: this.dateEnd,
            data: [this.selectedSoftware],
          });
          if (r) {
            this.tableItems = Object.entries(r).map(([key, value]) => ({
              method: key,
              count: value
            }));
            this.loading = false;
          }
        } catch (e) {
          console.error(e)
        }
      }
    },
    async createExcel() {
      if (this.tableItems.length !== 0) {
        try {
          const data = {
            "headers": [{ text: 'Метод', value: 'method', sortable: true }, { text: 'Всего', value: 'count', sortable: true, align: 'center' }],
            "body": this.tableItems
          };
          const response = await axios.post(
            this.url + "reports",
            data,
            {
              responseType: "blob",
            }
          );
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Базовые метрики (суммарно) - ${this.selectedSoftware}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          const snackbar = {
            show: true,
            message: error,
            color: 'error'
          };
          this.setSnackbar(snackbar);
          console.error("Ошибка при загрузке файла:", error);
        }
      }
    },
    createTableArray() {
      const data = [{ text: "Дата", sortable: false, value: "date" }];
      for (const key in this.softwareData) {
        const softName = this.softwareData[key];
        data.push({ text: softName, sortable: false, value: softName });
      }
      return data;
    },
  },
};
</script>


<style scoped>
.no-data-message {
  text-align: center;
  padding: 20px;
}
</style>